import { useRef } from '@codeleap/common'
import { TestPanel } from '@/app'

export function useToggleDevMode() {
  const pressesRef = useRef(0)
  const { enabled } = TestPanel.use()

  const onPress = () => {
    const newPresses = pressesRef.current + 1

    pressesRef.current = newPresses

    if (newPresses === 10) {
      TestPanel.toggleEnabled('user')
      pressesRef.current = 0
    }
  }

  return {
    onPress,
    isDevMode: enabled,
    loaded: true,
  }
}
